module.exports = __webpack_public_path__ + "static/media/Edit.7ee6892c.png";